import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {isNil} from '@optimaxdev/utils';

import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';

/**
 * Send Card Change Handler
 * @param {boolean | undefined} value - value
 */
export const saveCardChangeHandler = (value?: boolean) => {
    sendDesktopAnalyticsEvent(CHECKOUT_PAYMENT_STEP, {
        message: `Save credit card details - ${value ? 'Marked' : 'Unmarked'} - Checkbox`,
        method: 'Payment',
    });
};

/**
 * Send Analytics Event On Invalid
 */
export const sendAnalyticsEventOnInvalid = () => {
    sendDesktopAnalyticsEvent(
        CHECKOUT_PAYMENT_STEP,
        {
            message: 'Error - Required Fields Missing - nameOnCard',
            method: 'Credit card',
        },
        false,
    );
};

/**
 * Send error handler
 * @param {string | undefined} message - message
 * @param {boolean} isInteractive - isInteractive type of event
 */
export const errorHandler = (message?: string, isInteractive = false) => {
    const errorEventMessage = `Error – ${
        isNil(message) || message === '' ? 'Empty from paymentsos' : message
    }`;

    sendDesktopAnalyticsEvent(
        CHECKOUT_PAYMENT_STEP,
        {
            message: isInteractive ? `${errorEventMessage} - Place Order CTA` : errorEventMessage,
            method: 'Credit card',
        },
        isInteractive,
    );
};

/**
 * Send error on place order
 * @param {string | undefined} error - error
 */
export const sendAnalyticsOnPlaceOrder = (error?: string) => {
    if (error)
        sendDesktopAnalyticsEvent(CHECKOUT_PAYMENT_STEP, {
            message: `Error – ${error} - Place Order CTA`,
            method: 'Credit card',
        });
};
